<!-- header -->
<div class="header" id="header">
    <div class="headTop">
        <h1><a href="/" title="HOME" class="logo"></a></h1>
        <div class="hdMenu">
            <nav class="gnb">
                <ul>
                    <ng-container *ngFor="let item of mainMenu">
                        <ng-container *ngIf="item.menuLv === '1' && item.menuYn === 'Y' && item.prgKind === 'mh'">
                            <li [ngClass]="activeId === item.prgId ? 'active' : ''">
                                <a class="level-1" (click)="handleClickMenu(item);">
                                    {{ item.prgName }}
                                </a>
                                <ng-container *ngIf="item.prgId != 'mh.Mall'">
                                    <ul>
                                        <ng-container *ngFor="let item2 of mainMenuHome">
                                            <ng-container *ngIf="item.prgId === item2.pid">
                                                <ng-container *ngIf="item2.menuLv === '2' && item2.menuYn === 'Y'">
                                                    <li [ngClass]="activeId === item.prgId ? 'active' : ''">
                                                        <a [routerLink]="item2.linkInfo" class="level-1">
                                                            {{ item2.prgName }}
                                                        </a>
                                                    </li>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </ul>
                                </ng-container>
                                <ng-container *ngIf="item.prgId == 'mh.Mall'">
                                    <ul>
                                        <ng-container *ngFor="let item of pdtCates">
                                            <li>
                                                <a class="level-1" (click)="handleOnClickCategory(item);">
                                                    {{ item.cateName }}
                                                </a>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </ng-container>
                            </li>
                        </ng-container>
                    </ng-container>
                    <li>
                        <a [routerLink]="'/my-office/user-profile/personal-information'">MYOFFICE</a>
                        <ul>
                            <ng-container *ngFor="let item of mainMenu">
                                <ng-container
                                    *ngIf="item.menuLv === '1' && item.menuYn === 'Y' && item.prgKind === 'mo'">
                                    <li [ngClass]="activeId === item.prgId ? 'active' : ''">
                                        <a [routerLink]="item.linkInfo" class="level-1">
                                            {{ item.prgName }}
                                        </a>
                                    </li>
                                </ng-container>
                            </ng-container>
                        </ul>
                    </li>
                </ul>
            </nav>
            <div class="userMenu">
                <a href="/shopping-mall/cart" class="cart-icon">
                    장바구니
                </a>
                <ng-container *ngFor="let item of rightMenu;">
                    <ng-container
                        *ngIf="item.loginYn == 'A' || (isLogined && item.loginYn == 'Y') || (!isLogined && item.loginYn == 'N')">
                        <a href="javascript:;" (click)="handleOnClickRightMenu(item);">
                            {{ item.prgName }}
                        </a>
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <a class="slide-menu-open">
            <span></span>
            <span></span>
            <span></span>
        </a>
    </div>
</div>

<!-- mobi-left-slide -->
<div class="mobi-left-slide">
    <div class="slideTop">
        <ul>
            <li>
                <a href="/shopping-mall/cart" class="cart-icon">
                    장바구니
                </a>
            </li>
            <li>
                <ng-container *ngFor="let item of rightMenu;">
                    <ng-container
                        *ngIf="item.loginYn == 'A' || (isLogined && item.loginYn == 'Y') || (!isLogined && item.loginYn == 'N')">
                        <a class="level-1" href="javascript:;" (click)="handleOnClickRightMenu(item);">
                            {{ item.prgName }}
                        </a>
                    </ng-container>
                </ng-container>
            </li>
        </ul>
        <a class="close">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="40" height="40"
                viewBox="0 0 24 24" stroke-width="1" stroke="#fff" fill="none" stroke-linecap="round"
                stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M18 6l-12 12"></path>
                <path d="M6 6l12 12"></path>
            </svg>
        </a>
    </div>
    <div class="slideMenu">
        <ul>
            <ng-container *ngFor="let item of mainMenu">
                <ng-container *ngIf="item.menuLv === '1' && item.menuYn === 'Y' && item.prgKind === 'mh'">
                    <li [ngClass]="activeId === item.prgId ? 'active' : ''">
                        <a class="level-1" (click)="handleClickMenu(item);">
                            {{ item.prgName }}
                        </a>
                        <ng-container *ngIf="item.prgId != 'mh.Mall'">
                            <ul>
                                <ng-container *ngFor="let item2 of mainMenuHome">
                                    <ng-container *ngIf="item.prgId === item2.pid">
                                        <ng-container *ngIf="item2.menuLv === '2' && item2.menuYn === 'Y'">
                                            <li [ngClass]="activeId === item.prgId ? 'active' : ''">
                                                <a [routerLink]="item2.linkInfo" class="level-1">
                                                    {{ item2.prgName }}
                                                </a>
                                            </li>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </ul>
                        </ng-container>
                        <ng-container *ngIf="item.prgId == 'mh.Mall'">
                            <ul>
                                <ng-container *ngFor="let item of pdtCates">
                                    <li>
                                        <a class="level-1" (click)="handleOnClickCategory(item);">
                                            {{ item.cateName }}
                                        </a>
                                    </li>
                                </ng-container>
                            </ul>
                        </ng-container>
                    </li>
                </ng-container>
            </ng-container>
            <li>
                <a [routerLink]="'/my-office/user-profile/personal-information'">MYOFFICE</a>
                <ul>
                    <ng-container *ngFor="let item of mainMenu">
                        <ng-container *ngIf="item.menuLv === '1' && item.menuYn === 'Y' && item.prgKind === 'mo'">
                            <li [ngClass]="activeId === item.prgId ? 'active' : ''">
                                <a [routerLink]="item.linkInfo" class="level-1">
                                    {{ item.prgName }}
                                </a>
                            </li>
                        </ng-container>
                    </ng-container>
                </ul>
            </li>
        </ul>
    </div>
</div>
<!-- //mobi-left-slide -->

<board-popup></board-popup>
<app-autologout style="display: none;"></app-autologout>
<ngx-loading [show]="loading"></ngx-loading>